module.exports = __webpack_public_path__ + "static/media/emma-stone-win.f63055e2.jpg";